import { Component, ElementRef, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { Router } from '@angular/router';
import { ToastrService } from 'ngx-toastr';
import { Subject } from 'rxjs';
import { EstadoInfoFiviI } from 'src/app/modelos/EstadoInformacionFivi';
import { fuenteI } from 'src/app/modelos/fuentes.interface';
import { PeriodoReporteFiviI } from 'src/app/modelos/PeriodoReporteFivi';
import { VistaAdminInfoI } from 'src/app/modelos/VistaAdminInfo';
import { ApiService } from 'src/app/servicios/api/api.service';
import { AppServiceService } from 'src/app/servicios/AppService.service';
import { read, writeFileXLSX } from "xlsx";
import * as XLSX from 'xlsx';
import { ResCargueExcelAdminInfFiviI } from 'src/app/modelos/ResCargueExcelAdminInfFivi';
import { HistEstaInfoI } from 'src/app/modelos/HistorialEstadoInfo';
import { AnalisisService } from '../../../servicios/analisis/analisis.service';
import { DataTableDirective } from 'angular-datatables';
import { UsuarioI } from 'src/app/modelos/usuario.interface';
import { ResCargueExcelFivi } from 'src/app/modelos/ResCargueExcelFivi';
import { ConsultaFuenteI } from 'src/app/modelos/ConsultaFuente';
import { AdmininformacionService } from 'src/app/servicios/admininfo/admininformacion.service';

@Component({
  selector: 'app-consultarinfofivi',
  templateUrl: './consultarinfofivi.component.html',
  styleUrls: ['./consultarinfofivi.component.css']
})
export class ConsultarinfofiviComponent implements OnDestroy,OnInit {

  @ViewChild(DataTableDirective, { static: false }) dtElement: DataTableDirective;
  dtOptions: any = {};
  dtTrigger: Subject<any> = new Subject<any>();

  aniosVigen: Number[];
  PeriodoSeleccionado : PeriodoReporteFiviI = new PeriodoReporteFiviI;
  anioConsulta : Number = 0;
  consucutivoConsulta : Number = 0;

  PeriodosConsultar : PeriodoReporteFiviI[];
  ListaEstadosFuentes : VistaAdminInfoI[];
  IdPeriodoConsulta : BigInteger;
  PeriodoActivo : PeriodoReporteFiviI = new PeriodoReporteFiviI;
  EstadoVerObservaciones : EstadoInfoFiviI = new EstadoInfoFiviI;
  PeriodoModalVerOnservacion : String;
  FuenteVerObservaciones : fuenteI = new fuenteI;
  HistorialVerObservaciones : HistEstaInfoI = new HistEstaInfoI;
  usuarioAprobo : UsuarioI = new UsuarioI;
  rolUsuAprobo : String = "";
  ResultadoConsulta : any;
  isButtonBaseHistoricaDisabled: Boolean = false;
  ResultadoConsultaBase : any[];
  CargueMasivo : ConsultaFuenteI = new ConsultaFuenteI;

  @ViewChild('OpenModalObservacionesCargue') OpenModalObservacionesCargue: ElementRef;
  @ViewChild('CloseModalObservacionesCargue') CloseModalObservacionesCargue: ElementRef;

  constructor(
    private api:ApiService,
    private router:Router,
    private toastr: ToastrService,
    private appService:AppServiceService,
    private analisisService:AnalisisService,
    private admininfo:AdmininformacionService
  ) { }

  ngOnInit(): void {
    this.dtOptions = {
      pagingType: 'full_numbers',
      responsive: true,
      language:
        {
          "processing": "Procesando...",
          "lengthMenu": "Mostrar _MENU_ registros",
          "zeroRecords": "No se encontraron resultados",
          "emptyTable": "Ningún dato disponible en esta tabla",
          "infoEmpty": "Mostrando registros del 0 al 0 de un total de 0 registros",
          "infoFiltered": "(filtrado de un total de _MAX_ registros)",
          "search": "Buscar:",
          "loadingRecords": "Cargando...",
          "paginate": {
              "first": "Primero",
              "last": "Último",
              "next": "Siguiente",
              "previous": "Anterior"
          },
          "aria": {
              "sortAscending": ": Activar para ordenar la columna de manera ascendente",
              "sortDescending": ": Activar para ordenar la columna de manera descendente"
          },
          "info": "Mostrando de _START_ a _END_ de _TOTAL_ estados"
        }
    };
    this.api.listaPeriodosCalendarioFivi().subscribe(Lista1=>{
      this.PeriodosConsultar = Lista1;
    });
    this.analisisService.consultarPeriodoActivoFIVI().subscribe(PActivo=>{
      this.anioConsulta = Number(PActivo.anio);
      this.consucutivoConsulta = Number(PActivo.consecutivoPeriodo);
      this.PeriodoActivo = PActivo;
      this.IdPeriodoConsulta = PActivo.id;
      this.api.ListaEstadoInformacionFiviPorPeriodo(PActivo.id).subscribe(Lista=>{
        this.ListaEstadosFuentes = Lista;
        this.dtTrigger.next();
      });
    });
    this.analisisService.getListaAniosVigenciaFivi().subscribe(respuesta0=>{
      this.aniosVigen = respuesta0;
    });
  }

  ngOnDestroy(): void {
    this.dtTrigger.unsubscribe();
  }

  RegresarAdminChv(){
    this.router.navigate(['admininfofivi']);
  }

  peridoPorAnioMes(){
    this.analisisService.periodoFiviPorAnioMes(this.anioConsulta,this.consucutivoConsulta).subscribe(respuesta2=>{
      this.PeriodoSeleccionado = respuesta2;
      this.IdPeriodoConsulta = respuesta2.id;
      this.CosultarListaEstados(respuesta2.id);
    });
  }

  CosultarListaEstados(IdPeriodo){
    this.IdPeriodoConsulta = IdPeriodo;
    this.api.ListaEstadoInformacionFiviPorPeriodo(IdPeriodo).subscribe(result2=>{
      this.ListaEstadosFuentes = result2;
      this.reinicializarDataTable();
    });
  }

  reinicializarDataTable(): void {
    this.dtElement.dtInstance.then((dtInstance: any) => {
      dtInstance.destroy();
      this.dtTrigger.next();
    });
  }

  VerObservaciones(idEstadoInf){
    this.OpenModalObservacionesCargue.nativeElement.click();
    this.rolUsuAprobo = "";
    this.api.ConsultarEstadoInfoFiviPorId(idEstadoInf).subscribe(result3=>{
      this.EstadoVerObservaciones = result3;
      this.api.PeriodoFiviPorId(result3.idPeriodo.id).subscribe(Result4=>{
        this.PeriodoModalVerOnservacion = Result4.anio + " - " + Result4.consecutivoPeriodo;
      });
      this.api.getFuenteById(result3.idFuente.id).subscribe(Result5=>{
        this.FuenteVerObservaciones = Result5;
        this.api.HistEstadoInfAprobada(this.EstadoVerObservaciones.id,Result5.id).subscribe(result5=>{
          this.HistorialVerObservaciones = result5;
          /*this.api.getUsuarioByUsername(result5.usuario).subscribe(result=>{
            this.usuarioAprobo = result;
          });*/
          this.rolUsuAprobo = this.verificarPrimerosCaracteres(result5.usuario);
        });
      });
    });
  }

  verificarPrimerosCaracteres(cadena) {
    const primerosDos = cadena.substring(0, 2);

    if (primerosDos === 'ad' || primerosDos === 'AD') {
      return "Administrador";
    }else if (primerosDos === 'te' || primerosDos === 'TE') {
      return "Temático";
    }else if (primerosDos === 'co' || primerosDos === 'CO') {
      return "Coordinador";
    }else{
      return "Migración";
    }

  }

  ConsultarHistorico(idEstadoInf){
    this.api.ConsultarEstadoInfoFiviPorId(idEstadoInf).subscribe(result6=>{
      this.EstadoVerObservaciones = result6;
      this.api.PeriodoFiviPorId(result6.idPeriodo.id).subscribe(Result7=>{
        this.api.getFuenteById(result6.idFuente.id).subscribe(Result8=>{
          this.api.ConsultarReportePeriodoMensual(Result8.id,Result7.id).subscribe(Result9=>{
            this.ResultadoConsulta = Result9;
            //console.log(Result9);
            if(Result9.length == 0 || Result9 == null){
              this.toastr.error('Existe un problema con la información en requerida.', 'Error!');
            }else{
              console.log("aqui se genera el archivo.");
              let dto: Array<ResCargueExcelAdminInfFiviI> = new Array<ResCargueExcelAdminInfFiviI>();
              for (let i of this.ResultadoConsulta){
                let dat: ResCargueExcelAdminInfFiviI = new ResCargueExcelAdminInfFiviI();
                dat.ANIO = i.anio;
                dat.MES = i.mes;
                dat.OPERACION_FINANCIERA = i.cod_oper_fin;
                dat.SEXO_TITULAR = i.sexo_TITULAR;
                dat.EDAD_TITULAR = i.edad_titular;
                dat.DESTINO_CREDITO = i.des_cre;
                dat.SOLUCION_VIVIENDA = i.solu_viv;
                dat.DESTINO_CREDITO_VIVIENDA = i.des_cre_vivi;
                dat.DESTINO_CREDITO_CONSTRUCCION = i.des_cre_cons;
                dat.DEPARTAMENTO = i.depto;
                dat.MUNICIPIO = i.municipio;
                dat.DEPARTAMENTO_VIVIENDA = i.cod_dept_viv;
                dat.MUNICIPIO_VIVIENDA = i.cod_mun_viv;
                dat.SUBSIDIO = i.sub_sn;
                dat.TIPO_DE_SUBSIDIO = i.tip_sub;
                dat.MONEDA = i.moneda;
                dat.RANGO_VIVIENDA = i.ran_viv;
                dat.NUMERO_CREDITOS = i.num_cred;
                dat.VALOR_AVALUO = i.val_avaluo;
                dat.NUMERO_DE_DESEMBOLSO = i.num_desem;
                dat.VALOR_CREDITO = i.val_cred;
                dat.PLAZO_CREDITO = i.plaz_cred;
                dto.push(dat);
              }
              this.appService.CargueMasivoFiviAdminInfo(dto, 'Consulta '+Result7.anio+' '+Result7.consecutivoPeriodo+' '+Result8.codEnti);
            }
          });
        });
      });
    });
  }

  Descargar(){
    var workbook = XLSX.utils.book_new();
    var ws1 = XLSX.utils.table_to_sheet(document.getElementById('Consulta'));
    XLSX.utils.book_append_sheet(workbook, ws1, "Hoja1");
    XLSX.writeFile(workbook, "ConsultaInformacion.xlsx");
  }

  generarExcelInformacionConsultarInfo(){
    let titulosColumas = ["Periodo", "NIT", "Razón social", "Departamento", "Municipio", "Estado cargue", "Estado fuente", "Novedad"];
    let base64 = this.appService.generateExcelBase64AdminInfoConsultarInformacion(titulosColumas, this.ListaEstadosFuentes);
    let nombreArch = "Estado informacion "+this.anioConsulta+" - "+this.consucutivoConsulta+".xlsx";

    this.descargarArchivo(base64, nombreArch);
  }

  descargarArchivo(stringBase64, nombreArchivo) {
    if (stringBase64) {
      const blob = this.base64toBlob(stringBase64);
      const url = window.URL.createObjectURL(blob);

      const a = document.createElement('a');
      a.href = url;
      a.download = nombreArchivo;
      document.body.appendChild(a);
      a.click();
      window.URL.revokeObjectURL(url);
      document.body.removeChild(a);
    } else {
      console.error('No hay datos para descargar');
    }
  }

  base64toBlob(base64Data: string): Blob {
    const sliceSize = 512;
    const byteCharacters = atob(base64Data);
    const byteArrays: Uint8Array[] = [];

    for (let offset = 0; offset < byteCharacters.length; offset += sliceSize) {
      const slice = byteCharacters.slice(offset, offset + sliceSize);

      const byteNumbers = new Array(slice.length);
      for (let i = 0; i < slice.length; i++) {
        byteNumbers[i] = slice.charCodeAt(i);
      }

      const byteArray = new Uint8Array(byteNumbers);
      byteArrays.push(byteArray);
    }

    return new Blob(byteArrays, { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });
  }

  generarExcelBaseHistorica(){
    this.isButtonBaseHistoricaDisabled = true;

    this.CargueMasivo.anio = this.anioConsulta;
    this.CargueMasivo.trimestre = this.consucutivoConsulta;

    this.admininfo.consultarBaseHistoricaFivi(this.CargueMasivo).subscribe(Result =>{
      this.ResultadoConsultaBase = Result;

      let titulosColumas = ["Año", "Mes", "Código superintendencia", "Código tipo entidad", "Código entidad", "Operación financiera", "Sexo titular", "Edad titular", "Destino crédito", "Solución vivienda", "Destino crédito vivienda", "Destino crédito construcción", "Departamento", "Municipio", "Departamento vivienda", "Municpio vivienda", "Subsidio", "Tipo de subsido", "Moneda", "Rango vivienda", "Número créditos", "Valor avaluo", "Número desembolso", "Valor crédito", "Plazo crédito"];
      let base64 = this.appService.generateExcelBase64AdminInfoConsultarBaseHistoricaFIVI(titulosColumas, Result);

      this.descargarArchivo(base64, "Base Historica "+this.anioConsulta+" - "+this.consucutivoConsulta+".xlsx");

      this.isButtonBaseHistoricaDisabled = false;
    });
  }

}
